export { Icon } from './icon'